<template>
    <div>
        <ul class="nav nav-pills flex-column sidebar-custom">
            <li v-show="isAdmin || isUser">
                <router-link to="/" class="nav-link" active-class="active">
                    <i class="bi bi-arrow-right-short icon-indi"></i>  <i class="bi bi-speedometer2 me-2"></i>Painel
                </router-link>
            </li>
            <li>
                <router-link to="/resume" class="nav-link" active-class="active">
                    <i class="bi bi-arrow-right-short icon-indi"></i>  <i class="bi bi-speedometer2 me-2"></i>Resumo
                </router-link>
            </li>
            <li v-show="isAdmin || isUser">
                <router-link to="/rental" class="nav-link" active-class="active">
                    <i di class="bi bi-arrow-right-short icon-indi"></i>  <i class="bi bi-cart me-2"></i>Locações
                </router-link>
            </li>
            <li v-show="isAdmin || isUser">
                <router-link to="/stock" class="nav-link" active-class="active">
                    <i class="bi bi-arrow-right-short icon-indi"></i>  <i class="bi bi-box-seam me-2"></i>Estoque
                </router-link>
            </li>
            <li v-show="isAdmin || isUser">
                <router-link to="/stock/disponibility" class="nav-link" active-class="active">
                    <i class="bi bi-arrow-right-short icon-indi"></i>  <i class="bi bi-briefcase me-2"></i>Disponibilidade
                </router-link>
            </li>
            <li v-show="isAdmin || isUser">
                <router-link to="/category" class="nav-link" active-class="active">
                    <i class="bi bi-arrow-right-short icon-indi"></i>  <i class="bi bi-bookmarks me-2"></i>Categorias
                </router-link>
            </li>
            <li v-show="isAdmin || isUser">
                <router-link to="/client" class="nav-link" active-class="active">
                    <i class="bi bi-arrow-right-short icon-indi"></i>  <i class="bi bi-box-seam me-2"></i>Clientes
                </router-link>
            </li>
            <li v-show="isAdmin || isUser">
                <router-link to="/reports" class="nav-link" active-class="active">
                    <i class="bi bi-arrow-right-short icon-indi"></i>  <i class="bi bi-bar-chart-line me-2"></i>Relatórios
                </router-link>
            </li>
            <li>
                <router-link to="/movements" class="nav-link" active-class="active">
                    <i class="bi bi-arrow-right-short icon-indi"></i>  <i class="bi bi-arrow-left-right me-2"></i>Movimentações
                </router-link>
            </li>
            <li v-show="isAdmin">
                <router-link to="/tableprice" class="nav-link" active-class="active">
                    <i class="bi bi-arrow-right-short icon-indi"></i>  <i class="bi bi-tags me-2"></i>Tabelas de Preço
                </router-link>
            </li>
            <li v-show="isAdmin">
                <router-link to="/supplier" class="nav-link" active-class="active">
                    <i class="bi bi-arrow-right-short icon-indi"></i>  <i class="bi bi-box-seam me-2"></i>Fornecedores
                </router-link>
            </li>
            <li v-show="isAdmin">
                <router-link to="/users" class="nav-link" active-class="active">
                    <i class="bi bi-arrow-right-short icon-indi"></i>  <i class="bi bi-cart me-2"></i>Usuários
                </router-link> 
            </li>
            <li>
                <router-link to="/logout" class="nav-link" active-class="active">
                    <i class="bi bi-box-arrow-left"></i><i class="me-2"></i>Sair
                </router-link> 
            </li>
        </ul>
    </div>
</template>

<script>
import { usePermissions } from '@/composables/usePermissions';

export default {
    name: 'Sidebar',
    setup() {
        const { isAdmin, isUser, isOpeto } = usePermissions();
        return { isAdmin, isUser, isOpeto };
    }
}
</script>

<style scoped>

.icon-indi {
    display: none;
}

.sidebar-custom a {
    color: var(--lc3-text-sidebar);
    padding: 10px 15px;
    display: block;
    text-decoration: none;
}

.sidebar-custom li {
    border-radius: 0.375rem;
}

.sidebar-custom li:hover {
    background-color: var(--lc3-navbar-secundary);
}

.sidebar-custom li:hover a {
    color: var(--lc3-navbar-primary);
    font-weight: 500;
}

.nav-link.active {
    background-color: var(--lc3-navbar-primary) !important;
}

.nav-link.active .icon-indi {
    display: inline-block;
}

.nav-link.active a {
    color: #ffffff;
}

.nav-link.active:hover {
    background-color: var(--lc3-navbar-secundary) !important;
}

.nav-link.active:hover a {
    color: #d6d6d6 !important;
    font-weight: 500;
}

</style>